import React, { useState, useEffect } from "react";
import styles from "./AddOffline.module.css";
import { Container, Row, Col, Modal, InputGroup } from "react-bootstrap";
import moment from "moment";

// #region Components
import TimePicker from "../../components/TimePicker/TimePicker";
import TaskSearch from "../../components/TaskSearch/TaskSearch";
import ProjectSearchBar from "../../components/ProjectSearchBar/ProjectSearchBar";
import SupervisingClientSearchBar from "../../components/SupervisingClientSearchBar/SupervisingClientSearchBar";
import SpinnerButton from "../../components/SpinnerButton/SpinnerButton";
import Loading from "../../components/Loading/Loading";
// #endregion

//#region SLICE
import { showModal, showSpinner } from "./../../Slices/sessionSlice";
import { addOfflineSlot, getTrackerState } from "./../../Slices/candidateSlice";
import { useDispatch, useSelector } from "react-redux";
//#endregion
import { formatDuration, getDuration } from "./../../helpers/stubs";

//#region CONSTANTS
const saveId = "addOffline.save";
export const id = "ADD_OFFLINE_SLOT";
//#endregion

function AddOfflineSlot() {
  // need to be fetched from sessionSlice user

  //#region Slices
  const dispatch = useDispatch();
  const { selectedTask, selectedProject, selectedClient, sessionUser } =
    useSelector((state) => state.sessionSlice);
  const { selectedDay, workSlots, tracker } = useSelector(
    (state) => state.candidateSlice
  );
  //#endregion

  //#region States
  const [fromTime, setFromTime] = useState(null);
  const [toTime, setToTime] = useState(null);
  const [warning, setWarning] = useState(false);
  //#endregion

  // const candidateId = sessionUser.candidates[0]._id;



  //#region cheeck whether all fields are filled or not
  const noEmptyFields = () => {
    console.log("all :- ", {
      selectedClient,
      selectedProject,
      selectedTask,
      fromTime,
      toTime,
    });
    if (
      (selectedClient && selectedClient.length === 0) ||
      (selectedProject && selectedProject.length === 0) ||
      (selectedTask && selectedTask.length === 0) ||
      !fromTime ||
      !toTime
    ) {
      return true;
    }
    return false;
  };
  //#endregion

  //#region Validation
  const validateOfflineTask = () => {
    let isValidOfflineTime = true;
    workSlots.forEach((slot) => {
      if (
        moment(fromTime).isBetween(slot.slotFrom, slot.slotTo, "minutes") ||
        moment(toTime).isBetween(slot.slotFrom, slot.slotTo, "minutes")
      ) {
        isValidOfflineTime = false;
      } else if (
        moment(fromTime).isSameOrBefore(slot.slotFrom, "minutes") &&
        moment(toTime).isSameOrAfter(slot.slotTo, "minutes")
      ) {
        isValidOfflineTime = false;
      }
    });
    if (isValidOfflineTime) {
      const { _id: candidateId } = sessionUser.candidates.find(
        (candidate) =>
          candidate.supervisingClient.toString() === selectedClient[0]._id
      );
      console.log(candidateId);
      dispatch(showSpinner({ id: saveId }));
      return dispatch(
        addOfflineSlot({
          slotFrom: moment(fromTime).toISOString(),
          slotTo: moment(toTime).toISOString(),
          supervisingClient: selectedClient[0]._id,
          taskId: selectedTask[0]._id,
          taskName: selectedTask[0].name,
          projectId: selectedProject[0]._id,
          candidateId: candidateId,
          userId: sessionUser._id,
          day: moment(selectedDay).toISOString(),
        })
      );
    } else {
      setWarning(true);
      setTimeout(() => {
        setWarning(false);
      }, 5 * 1000);
    }
  };
  //#endregion


  return (
    <Modal
      show={true}
      onHide={() => {
        dispatch(showModal(null));
      }}
      size={"lg"}
    >
      <Modal.Header closeButton>
        <Modal.Title>{`Add Offline Time - ${moment(selectedDay).format(
          "ll"
        )}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  Task
                </InputGroup.Text>
                <Col sm="10">
                  <TaskSearch />
                </Col>
              </InputGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <InputGroup className="mb-3">
                <InputGroup.Text id="edit-position">Project</InputGroup.Text>
                <ProjectSearchBar />
              </InputGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <InputGroup className="mb-3">
                <InputGroup.Text id="edit-position">client</InputGroup.Text>
                <SupervisingClientSearchBar />
              </InputGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="4" className="text-center">
              <span>From</span>
              <TimePicker
                className={styles.time_picker}
                getSelectedTime={(e) => {
                  const day = moment(selectedDay).get("date");
                  const month = moment(selectedDay).get("month");
                  const year = moment(selectedDay).get("year");
                  const currentTime = moment(e)
                    .clone()
                    .set("date", day)
                    .set("month", month)
                    .set("year", year);
                  setFromTime(currentTime);
                }}
                label="from"
                placeHolderTime={moment(selectedDay)}
                noMeridian={false}
              />
            </Col>
            <Col sm="4" className="text-center">
              <span>To</span>
              <TimePicker
                className={styles.time_picker}
                getSelectedTime={(e) => {
                  const day = moment(selectedDay).get("date");
                  const month = moment(selectedDay).get("month");
                  const year = moment(selectedDay).get("year");
                  const currentTime = moment(e)
                    .clone()
                    .set("date", day)
                    .set("month", month)
                    .set("year", year);
                  setToTime(currentTime);
                }}
                label="to"
                // placeHolderTime={moment(selectedDay)}
                noMeridian={false}
              />
            </Col>
            <Col sm="4" className="">
              <div className="text-bottom">
                {fromTime && toTime && (
                  <div className="text-bottom mt-4">{`period :- ${formatDuration(
                    getDuration(fromTime, toTime)
                  )}`}</div>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            {warning && (
              <div className="text-start mt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="red"
                  className="bi bi-exclamation-triangle"
                  viewBox="0 0 16 16"
                >
                  <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                  <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                </svg>
                <span className="">
                  {" "}
                  work slot Already Exist For Entered Time Period
                </span>
              </div>
            )}
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <SpinnerButton
          id={saveId}
          variant="primary"
          onClick={validateOfflineTask}
          disabled={noEmptyFields()}
          name="Save"
        />
      </Modal.Footer>
    </Modal>
  );
}
export default AddOfflineSlot;
